
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerEditor()
    export class PoCNRTVAppEditors extends Serenity.LookupEditorBase<Serenity.LookupEditorOptions, PoCNRTVAppRow>{

        constructor(hidden: JQuery) {
            super(hidden);
        }

        protected getLookupKey() {
            return PoCNRTVAppRow.lookupKey;
        }

        // protected getItemText(item, lookup) {
        //     return super.getItemText(item, lookup) + ' [' + item.MbFirstName+']';
        // }
    }
}
